/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import {
  Modal as KoModal,
  ModalTitle,
  ModalContent,
  ModalActions
} from '@tfecom-thermofisher/react-komodo-design';
import PropTypes from 'prop-types';

import messages from 'src/messages';
import { Message, Button } from 'src/core/components';

import './style.scss';

const getDefaultActions = (
  cancelBtnLabel,
  submitBtnLabel,
  onCancel,
  onSubmit,
  submitDisabled = false
) => ([
  <Button
    data-testid="modal-default-submit-btn"
    key="modal-default-submit-btn"
    type="primary"
    onClick={onSubmit}
    label={submitBtnLabel || messages.submit}
    disabled={submitDisabled}
  />,
  <Button
    data-testid="modal-default-cancel-btn"
    key="modal-default-cancel-btn"
    type="outline"
    onClick={onCancel}
    label={cancelBtnLabel || messages.cancel}
  />
]);

const renderModalActions = (approveModalProps) => {
  const {
    cancelBtnLabel,
    submitBtnLabel,
    handleSubmit,
    handleClose,
    submitDisabled,
    actions = []
  } = approveModalProps || {};

  const defaultActions = getDefaultActions(
    cancelBtnLabel,
    submitBtnLabel,
    handleClose,
    handleSubmit,
    submitDisabled
  );

  return [...actions, ...defaultActions];
};

const renderModalDescription = (description = '') => (
  <div className="modal-description">
    <Message message={description} />
  </div>
);

const Modal = (props) => {
  const { id, isOpen, handleClose, title, content, description, size = 'small' } = props;
  const { values, ...message } = title || {};
  const modalTitle = <Message message={message} values={values} />;

  return (
    <KoModal id={id} designSize={size} isOpen={isOpen} handleClose={handleClose}>
      <ModalTitle title={modalTitle} handleClose={handleClose} />
      <ModalContent>
        <>
          {description && renderModalDescription(description)}
          {content}
        </>
      </ModalContent>
      <ModalActions>{renderModalActions(props)}</ModalActions>
    </KoModal>
  );
};

Modal.propTypes = {
  id: PropTypes.string,
  isOpen: PropTypes.bool,
  title: PropTypes.exact({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string.isRequired,
    values: PropTypes.object
  }).isRequired,
  cancelBtnLabel: PropTypes.exact({
    id: PropTypes.string,
    defaultMessage: PropTypes.string
  }),
  submitBtnLabel: PropTypes.exact({
    id: PropTypes.string,
    defaultMessage: PropTypes.string
  }),
  description: PropTypes.exact({
    id: PropTypes.string,
    defaultMessage: PropTypes.string
  }),
  actions: PropTypes.array,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  submitDisabled: PropTypes.bool,
  size: PropTypes.string
};

export default Modal;
